var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.getInstallUrl()}}},[_vm._v("+ Connect with Slack")]),_c('br')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }